import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Types from 'types';
import { userService } from 'services';

export const postSiteApprove = createAsyncThunk<
  Types.PostApproveResponse,
  Types.PostApproveRequest,
  Types.ThunkAPI<Types.PostApproveError>
>('post/approve', async (dataApproved, { rejectWithValue }) => {
  try {
    const { data } = await userService.postApproveItems(dataApproved);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
